import { LogEntry, LoggerProxyResponse } from './types';

import { post as basePost } from '../lowLevel';
import config from '@/config';

export const postLogEntries = async (
  logGroupName: string,
  logStreamName: string,
  logEvents: LogEntry[],
): Promise<boolean> => {
  try {
    const { data } = await post('log', {
      logGroupName,
      logStreamName,
      logEvents,
    });

    return (data as LoggerProxyResponse)?.result === 'success';
  } catch (error: any) {
    // Upload failures are reported through the return value rather than
    // thrown. Callers upload on a repeating timer and have to keep running
    // when a single upload fails, or logging stops for the rest of the session.
    console.error('postLogEntries', error);
    return false;
  }
};

const post = async (path: string, body: any): Promise<any> => {
  return basePost(
    [config.services.loggerProxyUrl],
    path,
    body,
    await getHeaders(),
  );
};

const getHeaders = async () => {
  const { clientId, clientSecret } = config.services.credentials;
  const bearer = btoa(`${clientId}:${clientSecret}`);

  return {
    Authorization: `Bearer ${bearer}`,
  };
};
